document.addEventListener('alpine:init', () => {
    Alpine.data('ElasticJobSearch', () => ({
        form: null,
        showOverlay: false,
        hasFilters: false,
        isLoading: false,
        mobileMenuOpen: false,
        filterMenuOpen: {
            "Distance": false,
            "Job Type": false,
            "Qualification": false,
            "Salary Range": false,
        },
        init() {
            window.placeFinderSubmit = this.handleSubmit.bind(this);
            this.initAccordion();
            this.initSelects();
            this.initForm();
            this.initFilters();
            this.togglePagination();

            if (window.addEventListener) {
                window.addEventListener('popstate', () => {
                    if (window.history.state === null) {
                        location.reload();
                    } else {
                        window.location = window.history.state.path;
                    }
                });
            }

            const searchParams = new URLSearchParams(window.location.search);

            if(searchParams.size) {
                this.hasFilters = true;
            } else {
                this.hasFilters = false;
            }

            const placeFinder = document.querySelector('input[name="filter_geotext"]');

            if (placeFinder) {
                placeFinder.addEventListener('focus', e => {
                    this.formFocus(true, e.target);
                });
                placeFinder.addEventListener('blur', e => {
                    this.formFocus(false, e.target);
                });
            }
        },

        /**
         * Initialize the accordion state
         */
        initAccordion() {
            for (const filterLabel in this.filterMenuOpen) {
                this.filterMenuOpen[filterLabel] = false;
            }
        },

        /**
         * Initialize the select fields
         */
        initSelects() {
            const selectFields = document.querySelectorAll('.Filter__Select');
            pegasus.selectField(selectFields, {
                openOnHover: false,
                firstItemDisabled: true,
                itemsToShow: 5,
                classNames: {
                    outerWrapper: '',
                    selector: 'Form__Selector flex relative z-[5000] justify-between w-full cursor-pointer body-base transition duration-300 bg-greyscale-white-08 border border-content-light items-center rounded-full shadow-sm flex-1 flex-1 px-5 py-[15px] text-blue-120 focus:outline-none',
                    selectorOpen: '-open',
                    selectionList: 'w-full mt-2 border border-brand-light-grey rounded-md bg-white z-[5001]',
                    listItem: 'text-content-dark body-base select-none relative transition duration-300 py-4 px-6',
                }
            });

            const filters = document.querySelectorAll('.filter');

            selectFields.forEach((select) => {
                select.addEventListener('pegasus-select-open', e => {
                    this.showOverlay = true;
                    filters.forEach(filter => {
                        // if filter isnt the parent of e.target
                        if (!filter.contains(e.target)) {
                            filter.classList.add('opacity-50');
                        }
                    });
                });
                select.addEventListener('pegasus-select-close', e => {
                    this.showOverlay = false;
                    filters.forEach(filter => {
                        filter.classList.remove('opacity-50');
                    });
                });
            });
        },

        formFocus(focus = true, elem) {

            const element = elem || this.$el;

            const filters = document.querySelectorAll('.filter');


            if (!focus) {
                this.showOverlay = false;
                filters.forEach(filter => {
                    filter.classList.remove('opacity-50');
                });
                return;
            }

            filters.forEach(filter => {
                if(!filter.contains(element)) {
                    filter.classList.add('opacity-50');
                }
            });

            this.showOverlay = true;
        },

        /**
         * Initialize the form
         */
        initForm() {
            this.form = document.querySelector('#ElasticSearchForm');
            this.form.addEventListener('submit', this.handleSubmit);
        },

        /**
         * Initialize the filters
         */
        initFilters() {
            this.form.querySelectorAll('.Filter__Select').forEach((select) => {
                select.addEventListener('change', window.placeFinderSubmit);
            });
            // all checkboxes by inpyt type on the form
            this.form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                checkbox.addEventListener('change',  window.placeFinderSubmit);
            });
            // The search textbox by name filter_search
            this.form.querySelector('input[name="filter_search"]').addEventListener('keydown',  function (event) {
                if (event.key !== 'Enter') return;
                event.preventDefault();
                window.placeFinderSubmit();
            });
        },

        /**
         * Handle the form submit
         * @param e
         * @param force
         */
        handleSubmit(e, force) {
            if (e) {
                e.preventDefault();
            }

            if (document.getElementsByTagName('body')[0].classList.contains('filter-open') ) {
                if (!force) {
                    return;
                }
            }
            this.form.querySelector('input[name="filter_page"]').value = 1;
            this.totalResults = 0;
            const formData = new FormData(document.querySelector('#ElasticSearchForm'));
            const searchParams = new URLSearchParams(formData).toString();
            const url = new URL(window.location.href);
            this.fetchContent(url.pathname + '?' + searchParams);

            if(searchParams.length) {
                this.hasFilters = true;
            } else {
                this.hasFilters = false;
            }
        },

        /**
         * Fetch the content and replaces it
         * @param url
         */
        fetchContent(url){
            const elements = ['data-pegasus-filterable="filters"', 'data-pegasus-filterable="results"'];

            //show LoadingScreen
            this.isLoading = true;
            const historyUrl = url;
            pegasus.ajaxContent(url, elements, {}, () => {
                document.getElementById('LoadingScreen').style.display='none';
                this.initAccordion();
                this.initSelects();
                this.initFilters();
                if (document.getElementsByTagName('body')[0].classList.contains('filter-open') ) {
                    this.closeFilters();
                }
                this.togglePagination();
                this.pushToHistory(document.title, historyUrl);

                pegasus.scroll(document.body);
                this.isLoading = false;
            });
        },

        /**
         * Load more results
         */
        loadMore() {
            this.form.querySelector('input[name="filter_page"]').value = parseInt(this.form.querySelector('input[name="filter_page"]').value) + 1;
            const url = new URL(window.location.href);
            const formData = new FormData(document.querySelector('#ElasticSearchForm'));
            const searchParams = new URLSearchParams(formData).toString();
            this.fetchAndAppend(url.pathname + '?' + searchParams);
        },

        /**
         * Fetch the content and append it
         * @param url
         */
        fetchAndAppend(url) {
            const elements = ['data-pegasus-filterable="results"'];

            //show LoadingScreen
            document.getElementById('LoadingScreen').style.display='block';
            pegasus.ajaxFetchAndAppendContent(url, elements, {}, () => {
                document.getElementById('LoadingScreen').style.display='none';
                this.initAccordion();
                this.initSelects();
                this.initFilters();
                if (document.getElementsByTagName('body')[0].classList.contains('filter-open') ) {
                    this.closeFilters();
                }
                this.togglePagination();
            });
        },

        /**
         * Open the filter menu on mobile
         */
        openMenu() {
            document.getElementsByTagName('body')[0].classList.add('filter-open');
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            window.scrollTo(0, 0);
        },

        /**
         * Close the filter menu on mobile
         */
        closeFilters() {
            document.getElementsByTagName('body')[0].classList.remove('filter-open');
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
        },

        /**
         * Toggle the visibility of the pagination button
         */
        togglePagination() {
            const p = document.querySelector('.ElasticFilter__Pagination');
            if (!p) return;
            if ((parseInt(this.form.querySelector('input[name="filter_page"]').value) * parseInt(this.form.querySelector('input[name="page_size"]').value)) < parseInt(this.form.querySelector('input[name="total"]').value)) {
                p.style.display = 'block';
            } else {
                p.style.display = 'none';
            }
        },

        /**
         * Check if the browser supports history
         * @returns {boolean}
         */
        historySupported() {
            return !!(window.history && history.pushState);
        },

        /**
         * pushing a title and an url into the history
         * @param title
         * @param url
         */
        pushToHistory(title, url) {
            if (this.historySupported()) {
                history.pushState({ path: url }, title, url);
            }
        },
    }));
});
